__turbopack_context__.v({
  "buySection": "index-module__tHv7jG__buySection",
  "desktopPrimaryOffers": "index-module__tHv7jG__desktopPrimaryOffers",
  "disclaimerButton": "index-module__tHv7jG__disclaimerButton",
  "disclaimerButtonContainer": "index-module__tHv7jG__disclaimerButtonContainer",
  "heightOpacityIn": "index-module__tHv7jG__heightOpacityIn",
  "largePrompt": "index-module__tHv7jG__largePrompt",
  "learnMoreButton": "index-module__tHv7jG__learnMoreButton",
  "leftPanel": "index-module__tHv7jG__leftPanel",
  "limitedEditionBanner": "index-module__tHv7jG__limitedEditionBanner",
  "mobileCarouselSection": "index-module__tHv7jG__mobileCarouselSection",
  "mobilePrimaryOffers": "index-module__tHv7jG__mobilePrimaryOffers",
  "notServicableMessageContainer": "index-module__tHv7jG__notServicableMessageContainer",
  "outOfStockBanner": "index-module__tHv7jG__outOfStockBanner",
  "powerPlugSubsection": "index-module__tHv7jG__powerPlugSubsection",
  "priceContentContainer": "index-module__tHv7jG__priceContentContainer",
  "rightPanel": "index-module__tHv7jG__rightPanel",
  "root": "index-module__tHv7jG__root",
  "section": "index-module__tHv7jG__section",
  "separator": "index-module__tHv7jG__separator",
  "sizeInfoModal": "index-module__tHv7jG__sizeInfoModal",
  "stickyPanel": "index-module__tHv7jG__stickyPanel",
});
